export const LUXON_LOCALE_MAPPER: Record<string, string> = {
  en: 'en-DE',
  it: 'it-IT',
};
